// Store price (DonGia) vs Grab & Foody price (DonGia2) for cart lines.
//
// A cart line keeps `basePrice` (DonGia) and `price2` (DonGia2) next to the
// active `price`, so the cart can switch back and forth when the cashier
// toggles Grab & Foody after adding items.

const toPrice = (value) => {
  if (value === null || value === undefined || value === "") return null;
  const number = Number(value);
  return Number.isFinite(number) ? number : null;
};

export const getChannelPrice = (item, isGrabFoodyMode) => {
  const base = toPrice(item?.basePrice ?? item?.price) ?? 0;
  if (!isGrabFoodyMode) return base;
  return toPrice(item?.price2) ?? base;
};

// Copies the product's store price into `basePrice` and sets `price` for the
// active channel. Use it whenever a product becomes a cart line.
export const withChannelPrice = (product, isGrabFoodyMode) => {
  const basePrice = toPrice(product?.basePrice ?? product?.price) ?? 0;
  const line = { ...product, basePrice };
  return { ...line, price: getChannelPrice(line, isGrabFoodyMode) };
};

// Reprices every line that knows both prices. Lines without `basePrice`
// (added by older code paths) keep their price. Returns the same array when
// nothing changes so React can skip the update.
export const repriceOrderItems = (items, isGrabFoodyMode) => {
  if (!Array.isArray(items)) return items;
  let changed = false;
  const next = items.map((item) => {
    if (!item || item.basePrice === undefined || item.basePrice === null) return item;
    const price = getChannelPrice(item, isGrabFoodyMode);
    if (Number(item.price) === price) return item;
    changed = true;
    return { ...item, price };
  });
  return changed ? next : items;
};
